import {useCallback, useState} from 'react';

export function useFileDragDrop({
  disabled,
  multiple,
  onFilesSelect
}: {
  disabled: boolean;
  multiple: boolean;
  onFilesSelect: (files: File[]) => void;
}): {
  isDragActive: boolean;
  dragProps: {
    onDragEnter: React.DragEventHandler;
    onDragLeave: React.DragEventHandler;
    onDragOver: React.DragEventHandler;
    onDrop: React.DragEventHandler;
  };
} {
  const [isDragActive, setIsDragActive] = useState(false);

  const onDragEnter = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (!disabled) setIsDragActive(true);
    },
    [disabled]
  );

  const onDragLeave = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  }, []);

  const onDragOver = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (!disabled) setIsDragActive(true);
    },
    [disabled]
  );

  const onDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragActive(false);
      if (disabled) return;
      const files = Array.from(e.dataTransfer.files);
      if (files.length > 0) {
        onFilesSelect(multiple ? files : files.slice(0, 1));
      }
    },
    [disabled, multiple, onFilesSelect]
  );

  return {
    isDragActive,
    dragProps: {onDragEnter, onDragLeave, onDragOver, onDrop}
  };
}
